import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'chat', en);
i18next.addResources('fr', 'chat', fr);

declare global {
  interface RegisteredLocales {
    chat: typeof en;
  }
}
